angular.module('elfium').service('userService', ['$uibModal', 'elfiumRestService', 'elfiumUrlService',
    function ($uibModal, elfiumRestService, elfiumUrlService) {
        var that = this;
        that.getUsers = function () {
            return elfiumRestService.getUsers();
        };
        that.getUser = function (userId)  {
            return elfiumRestService.getUser(userId);
        };
        that.updateUser = function (user) {
            return elfiumRestService.updateUser(user);
        };
        that.openUserDetailModal = function (userId) {
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('user', 'userDetailModal'),
                controller: 'userDetailModalController',
                resolve: {
                    userId: function () {
                        return userId;
                    }
                }
            });
            return modalInstance.result;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/user/userService.ts